/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { StoragePolicy } from '../model/storagePolicy';
import { StoragePolicyCreateRequest } from '../model/storagePolicyCreateRequest';
import { StoragePolicyKeys } from '../model/storagePolicyKeys';
import { StoragePolicySearchRequest } from '../model/storagePolicySearchRequest';
import { StoragePolicySearchResponse } from '../model/storagePolicySearchResponse';
import { StoragePolicyUpdateRequest } from '../model/storagePolicyUpdateRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class StoragePolicyService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createStoragePolicy
     * Creates a new storage policy. &lt;p&gt;Requires WRITE permission on storage policy namespace and storage policy filter namespace&lt;/p&gt;
     * @param storagePolicyCreateRequest the information needed to create the storage policy
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storagePolicyCreateStoragePolicy(storagePolicyCreateRequest: StoragePolicyCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<StoragePolicy>;
    public storagePolicyCreateStoragePolicy(storagePolicyCreateRequest: StoragePolicyCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoragePolicy>>;
    public storagePolicyCreateStoragePolicy(storagePolicyCreateRequest: StoragePolicyCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoragePolicy>>;
    public storagePolicyCreateStoragePolicy(storagePolicyCreateRequest: StoragePolicyCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (storagePolicyCreateRequest === null || storagePolicyCreateRequest === undefined) {
            throw new Error('Required parameter storagePolicyCreateRequest was null or undefined when calling storagePolicyCreateStoragePolicy.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<StoragePolicy>(`${this.configuration.basePath}/storagePolicies`,
            storagePolicyCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteStoragePolicy
     * Deletes an existing storage policy by key. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param storagePolicyName the storage policy name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storagePolicyDeleteStoragePolicy(namespace: string, storagePolicyName: string, observe?: 'body', reportProgress?: boolean): Observable<StoragePolicy>;
    public storagePolicyDeleteStoragePolicy(namespace: string, storagePolicyName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoragePolicy>>;
    public storagePolicyDeleteStoragePolicy(namespace: string, storagePolicyName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoragePolicy>>;
    public storagePolicyDeleteStoragePolicy(namespace: string, storagePolicyName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling storagePolicyDeleteStoragePolicy.');
        }
        if (storagePolicyName === null || storagePolicyName === undefined) {
            throw new Error('Required parameter storagePolicyName was null or undefined when calling storagePolicyDeleteStoragePolicy.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<StoragePolicy>(`${this.configuration.basePath}/storagePolicies/namespaces/${encodeURIComponent(String(namespace))}/storagePolicyNames/${encodeURIComponent(String(storagePolicyName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getStoragePolicy
     * Gets an existing storage policy by key. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param storagePolicyName the storage policy name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storagePolicyGetStoragePolicy(namespace: string, storagePolicyName: string, observe?: 'body', reportProgress?: boolean): Observable<StoragePolicy>;
    public storagePolicyGetStoragePolicy(namespace: string, storagePolicyName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoragePolicy>>;
    public storagePolicyGetStoragePolicy(namespace: string, storagePolicyName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoragePolicy>>;
    public storagePolicyGetStoragePolicy(namespace: string, storagePolicyName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling storagePolicyGetStoragePolicy.');
        }
        if (storagePolicyName === null || storagePolicyName === undefined) {
            throw new Error('Required parameter storagePolicyName was null or undefined when calling storagePolicyGetStoragePolicy.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<StoragePolicy>(`${this.configuration.basePath}/storagePolicies/namespaces/${encodeURIComponent(String(namespace))}/storagePolicyNames/${encodeURIComponent(String(storagePolicyName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getStoragePolicyKeys
     * Gets a list of keys for all storage policies defined in the system for the specified namespace. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storagePolicyGetStoragePolicyKeys(namespace: string, observe?: 'body', reportProgress?: boolean): Observable<StoragePolicyKeys>;
    public storagePolicyGetStoragePolicyKeys(namespace: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoragePolicyKeys>>;
    public storagePolicyGetStoragePolicyKeys(namespace: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoragePolicyKeys>>;
    public storagePolicyGetStoragePolicyKeys(namespace: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling storagePolicyGetStoragePolicyKeys.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<StoragePolicyKeys>(`${this.configuration.basePath}/storagePolicies/namespaces/${encodeURIComponent(String(namespace))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchStoragePolicies
     * Retrieves all storage policies existing in the system per specified search filters and keys. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param storagePolicySearchRequest the storage policy search request
     * @param fields the field options for the storage policy search response. The valid field options are: storagePolicyRule, storagePolicyFilter, storagePolicyTransition, status
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storagePolicySearchStoragePolicies(storagePolicySearchRequest: StoragePolicySearchRequest, fields?: string, observe?: 'body', reportProgress?: boolean): Observable<StoragePolicySearchResponse>;
    public storagePolicySearchStoragePolicies(storagePolicySearchRequest: StoragePolicySearchRequest, fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoragePolicySearchResponse>>;
    public storagePolicySearchStoragePolicies(storagePolicySearchRequest: StoragePolicySearchRequest, fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoragePolicySearchResponse>>;
    public storagePolicySearchStoragePolicies(storagePolicySearchRequest: StoragePolicySearchRequest, fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (storagePolicySearchRequest === null || storagePolicySearchRequest === undefined) {
            throw new Error('Required parameter storagePolicySearchRequest was null or undefined when calling storagePolicySearchStoragePolicies.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fields !== undefined && fields !== null) {
            queryParameters = queryParameters.set('fields', <any>fields);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<StoragePolicySearchResponse>(`${this.configuration.basePath}/storagePolicies/search`,
            storagePolicySearchRequest,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateStoragePolicy
     * Updates an existing storage policy by key. &lt;p&gt;Requires WRITE permission on storage policy namespace and storage policy filter namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param storagePolicyName the storage policy name
     * @param storagePolicyUpdateRequest the information needed to update the storage policy
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storagePolicyUpdateStoragePolicy(namespace: string, storagePolicyName: string, storagePolicyUpdateRequest: StoragePolicyUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<StoragePolicy>;
    public storagePolicyUpdateStoragePolicy(namespace: string, storagePolicyName: string, storagePolicyUpdateRequest: StoragePolicyUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoragePolicy>>;
    public storagePolicyUpdateStoragePolicy(namespace: string, storagePolicyName: string, storagePolicyUpdateRequest: StoragePolicyUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoragePolicy>>;
    public storagePolicyUpdateStoragePolicy(namespace: string, storagePolicyName: string, storagePolicyUpdateRequest: StoragePolicyUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling storagePolicyUpdateStoragePolicy.');
        }
        if (storagePolicyName === null || storagePolicyName === undefined) {
            throw new Error('Required parameter storagePolicyName was null or undefined when calling storagePolicyUpdateStoragePolicy.');
        }
        if (storagePolicyUpdateRequest === null || storagePolicyUpdateRequest === undefined) {
            throw new Error('Required parameter storagePolicyUpdateRequest was null or undefined when calling storagePolicyUpdateStoragePolicy.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<StoragePolicy>(`${this.configuration.basePath}/storagePolicies/namespaces/${encodeURIComponent(String(namespace))}/storagePolicyNames/${encodeURIComponent(String(storagePolicyName))}`,
            storagePolicyUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
